/**
 * Back in Stock -- Klaviyo Client API
 * Handles BIS subscription forms on product pages and pack picker modals.
 * Version: 1.0.0
 */
(function () {
  "use strict";

  var KLAVIYO_API = "https://a.klaviyo.com/client/back-in-stock-subscriptions/";
  var KLAVIYO_REVISION = "2026-04-15";

  function normalizeCompanyId(value) {
    if (typeof value !== "string") return null;
    var companyId = value.trim();
    return companyId || null;
  }

  // Resolve company ID from valid string sources only.
  function getCompanyId() {
    var script = document.querySelector("[data-bis-company-id]");
    var scriptCompanyId = script ? normalizeCompanyId(script.getAttribute("data-bis-company-id")) : null;
    if (scriptCompanyId) {
      return scriptCompanyId;
    }

    var klaviyoCompanyId = window.klaviyo ? normalizeCompanyId(window.klaviyo._companyId) : null;
    if (klaviyoCompanyId) {
      return klaviyoCompanyId;
    }

    if (window._learnq && window._learnq.length) {
      for (var i = 0; i < window._learnq.length; i++) {
        var item = window._learnq[i];
        var learnqCompanyId = Array.isArray(item) && item[0] === "account" ? normalizeCompanyId(item[1]) : null;
        if (learnqCompanyId) {
          return learnqCompanyId;
        }
      }
    }

    return null;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // Translations from each rendered form or the legacy page-level JSON contract
  var t = {};

  // Load translations from the page if available
  var langScript = document.getElementById("bis-translations");
  if (langScript) {
    try {
      var parsed = JSON.parse(langScript.textContent);
      for (var key in parsed) {
        if (parsed[key]) t[key] = parsed[key];
      }
    } catch (e) {
      // Use defaults
    }
  }

  function getFormTranslations(form) {
    var submitBtn = form.querySelector("[data-bis-submit]");
    return {
      submitting: form.getAttribute("data-bis-submitting") || t.submitting,
      success: form.getAttribute("data-bis-success") || t.success,
      error: form.getAttribute("data-bis-error") || t.error,
      subscribed: form.getAttribute("data-bis-subscribed") || t.subscribed,
      invalid_email: form.getAttribute("data-bis-invalid-email") || t.invalid_email,
      submit: form.getAttribute("data-bis-submit-label") || t.submit || (submitBtn ? submitBtn.textContent.trim() : ""),
    };
  }

  function handleSubmit(form) {
    var translations = getFormTranslations(form);
    var emailInput = form.querySelector("[data-bis-email]");
    var submitBtn = form.querySelector("[data-bis-submit]");
    // Guard the Enter-key path: disabled button already blocks the click path
    if (submitBtn && submitBtn.disabled) return;
    var statusEl = form.querySelector("[data-bis-status]");
    var variantId = form.getAttribute("data-bis-variant-id");
    var email = emailInput ? emailInput.value.trim() : "";

    if (!statusEl || !submitBtn || !emailInput) return;
    var requestId = String(Number(form.dataset.bisRequestId || 0) + 1);
    form.dataset.bisRequestId = requestId;

    // Clear previous status
    statusEl.textContent = "";
    statusEl.className = "bis-form-2026__status";

    if (!email || !isValidEmail(email)) {
      statusEl.textContent = translations.invalid_email;
      statusEl.classList.add("bis-form-2026__status--error");
      return;
    }

    if (!variantId) {
      statusEl.textContent = translations.error;
      statusEl.classList.add("bis-form-2026__status--error");
      return;
    }

    var companyId = getCompanyId();
    if (!companyId) {
      statusEl.textContent = translations.error;
      statusEl.classList.add("bis-form-2026__status--error");
      return;
    }

    // Disable button
    submitBtn.disabled = true;
    submitBtn.textContent = translations.submitting;

    var payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: "$shopify:::$default:::" + variantId,
            },
          },
        },
      },
    };

    fetch(KLAVIYO_API + "?company_id=" + encodeURIComponent(companyId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: KLAVIYO_REVISION,
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        if (form.dataset.bisRequestId !== requestId) return;
        if (response.status === 202 || response.ok) {
          statusEl.textContent = translations.success;
          statusEl.classList.add("bis-form-2026__status--success");
          submitBtn.textContent = translations.subscribed;
          submitBtn.disabled = true;
          emailInput.disabled = true;
        } else {
          throw new Error("API error: " + response.status);
        }
      })
      .catch(function () {
        if (form.dataset.bisRequestId !== requestId) return;
        statusEl.textContent = translations.error;
        statusEl.classList.add("bis-form-2026__status--error");
        submitBtn.disabled = false;
        submitBtn.textContent = translations.submit;
      });
  }

  // Reset form to initial state (used by pack picker when switching variants)
  function resetForm(form) {
    form.dataset.bisRequestId = String(Number(form.dataset.bisRequestId || 0) + 1);
    var translations = getFormTranslations(form);
    var emailInput = form.querySelector("[data-bis-email]");
    var submitBtn = form.querySelector("[data-bis-submit]");
    var statusEl = form.querySelector("[data-bis-status]");
    if (emailInput) {
      emailInput.disabled = false;
    }
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = translations.submit;
    }
    if (statusEl) {
      statusEl.textContent = "";
      statusEl.className = "bis-form-2026__status";
    }
  }

  // Expose resetForm globally for pack picker integration
  window.bisResetForm = resetForm;

  // Event delegation
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-bis-submit]");
    if (!btn) return;
    var form = btn.closest("[data-bis-form]");
    if (form) handleSubmit(form);
  });

  // Allow submit on Enter key
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter") return;
    var input = e.target.closest("[data-bis-email]");
    if (!input) return;
    e.preventDefault();
    var form = input.closest("[data-bis-form]");
    if (form) handleSubmit(form);
  });
})();
